import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
    NavController,
    NavParams
} from 'ionic-angular';

import { Rodeo } from '../../../../model/rodeo';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { RodeoEventSchedule } from '../../../../model/rodeoEventSchedule';
import { Account } from '../../../../model/account';
import { ApiService } from '../../../../services/api';
import { Subscription } from 'rxjs';
import { PrintService } from '../../../../services/print-service';
import { FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { RunService } from '../../../../services/run.service';
import { DateHelperService } from '../../../../services/date-helper';

@Component({
    selector: 'page-secretary-sheets-report',
    templateUrl: 'report-secretary-sheets.html'

})
export class SecretarySheetsReport implements OnInit, OnDestroy {
    @Input('rodeo') rodeo: Rodeo;
    @Input('options') options: FormGroup;
    rodeoEvents: RodeoEvent[] = [];
    matchingMemberships: number[] = [];

    imageOrganization:string = '';

    popoverActive: boolean;
    dataLoaded: boolean;
    printing: boolean;

    schedulesToDisplay: any[] = [];
    hasNonPermitMembership: any[] = [];

    private subscriptions: Subscription[] = [];

    constructor(private printService: PrintService, private nav: NavController, private navParams: NavParams, public api: ApiService, private datePipe: DatePipe, private runService: RunService, public dateHelper: DateHelperService) {
    }

    ngOnInit(): void {
        if (!this.rodeo)
            this.rodeo = this.navParams.get('rodeo');

        //set up form listeners
        this.subscriptions.push(
            this.options.valueChanges.subscribe((e) => this.updateFromFormValues(e))
        );

        this.subscriptions.push(
            this.printService.printing.subscribe(printing => this.printing = printing)
        );

        //init the page
        this.updateFromFormValues(this.options.value);

        this.imageOrganization = this.rodeo.organization.logoFileName;        
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(x => x.unsubscribe());
    }

    updateFromFormValues(filters) {
        if (filters.rodeoEventId > 0) {
            this.rodeoEvents = this.rodeo.rodeoEvents.filter(x => x.id == filters.rodeoEventId);
        } else {
            const slack = !!filters.scheduleName && !!filters.scheduleName.toLowerCase().includes('slack');
            this.rodeoEvents = this.rodeo.rodeoEvents.filter(x => x.schedules && x.schedules.length > 0 && x.schedules.find(y => y.runs && y.runs.length > 0))
            .sort((a,b) => {
                if (a.eventOrders && b.eventOrders) {
                    return a.eventOrders.find(x => x.slack == slack).eventOrder - b.eventOrders.find(x => x.slack == slack).eventOrder;
                } else {
                    return a.id - b.id;
                }
            });;
        }

        // console.log(this.rodeoEvents);
        this.load();
        this.updateRodeoEvents(filters);
        this.dataLoaded = true;
    }


    load() {
        this.rodeo.organization.memberships.forEach(membership => {
            this.matchingMemberships.push(membership.id);
        });

        this.rodeo.sanctionedOrganizations.forEach(organization => {
            organization.memberships.forEach(membership => {
                this.matchingMemberships.push(membership.id);
            });
        });

        this.dataLoaded = true;
    }

    updateRodeoEvents(filters) {
        this.schedulesToDisplay = [];

        this.rodeoEvents.forEach((rodeoEvent) => {
            rodeoEvent.registrations.forEach(registration => {
				if (registration.contestantOne.memberships.some(x => !x.permit && !x.isExpired && this.rodeo.organization.memberships.some(y => y.id == x.membershipId))) {
					this.hasNonPermitMembership[registration.contestantOne.id] = true;
                }

				if (registration.contestantTwo && registration.contestantTwo.memberships.some(x => !x.permit && !x.isExpired && this.rodeo.organization.memberships.some(y => y.id == x.membershipId))) {
					this.hasNonPermitMembership[registration.contestantTwo.id] = true;
                }
			});

            rodeoEvent.schedules
                .sort((a, b) => new Date(a.scheduledDate).getTime() - new Date(b.scheduledDate).getTime())
                .forEach((schedule) => {                    
                    if (filters.scheduleName && filters.scheduleName !== "" && filters.scheduleName !== schedule.name)
                        return;

                    if (filters.round > 0) {
                        let scheduleToAdd = { ...schedule, runs: this.runService.getRuns(this.rodeo, rodeoEvent, schedule, filters.round) };

                        if (scheduleToAdd.runs.length > 0) {
                            if (!this.schedulesToDisplay[schedule.id]) {
                                this.schedulesToDisplay[schedule.id] = [];
                            }

                            this.schedulesToDisplay[schedule.id].push(scheduleToAdd);
                        }
                    } else {
                        var scheduleRounds = [...new Set(schedule.runs.map(x => x.round))];

                        scheduleRounds.forEach((round) => {
                            let scheduleToAdd = { ...schedule, runs: this.runService.getRuns(this.rodeo, rodeoEvent, schedule, round) };

                            if (scheduleToAdd.runs.length > 0) {
                                if (!this.schedulesToDisplay[schedule.id]) {
                                    this.schedulesToDisplay[schedule.id] = [];
                                }

                                this.schedulesToDisplay[schedule.id].push(scheduleToAdd);
                            }
                        });
                    }
            });
        });
    }

    isRoughStock(rodeoEvent: RodeoEvent) {
        if (rodeoEvent.eventType === 'BullRiding' || rodeoEvent.eventType === 'SaddleBroncRiding' || rodeoEvent.eventType === 'RanchBroncRiding' || rodeoEvent.eventType === 'BarebackRiding')
            return true;
        else
            return false;
    }

    getMembershipIds(account: Account) {
        return [...new Set(account.memberships.filter(x => this.matchingMemberships.some(y => y == x.membership.id) && Date.parse(x.expiration) > Date.now()).map(x => x.id))];
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/reports/report-secretary-sheets.ts